<div class="embed-responsive">
  <iframe #iframe class="embed-responsive-item" (load)="uploadDone()" [src]=" url | safeUrl"></iframe>
</div>
